import { useCallback, useEffect, useState } from "react";
import apiClient from "../api/apiClient";

export default function AllTrips() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  // ================= FETCH ALL TRIPS =================
  const fetchTrips = useCallback(async () => {
    try {
      const res = await apiClient.get("/admin/rides", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTrips(res.data);
    } catch {
      setTrips([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchTrips();
  }, [fetchTrips]);

  return (
    <>
      <h2 className="page-title">All Trips</h2>

      {loading ? (
        <p>Loading trips...</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Pickup</th>
              <th>Drop</th>
              <th>Distance</th>
              <th>Duration</th>
              <th>Vehicle</th>
              <th>Fare</th>
              <th>Driver</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {trips.map((t) => (
              <tr key={t.id}>
                <td>{t.id}</td>
                <td>{t.userId}</td>

                <td title={t.pickupAddress}>
                  {t.pickupAddress?.slice(0, 30)}...
                </td>

                <td title={t.dropAddress}>
                  {t.dropAddress?.slice(0, 30)}...
                </td>

                <td>{t.distanceText}</td>
                <td>{t.durationText}</td>
                <td>{t.vehicleInfo}</td>

                <td>₹{t.finalFare}</td>

                <td>{t.driverId ? t.driverId : "Not Assigned"}</td>

                <td>
                  <span className={`status ${t.status.toLowerCase()}`}>
                    {t.status}
                  </span>
                </td>

                <td>
                  {new Date(t.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
